import { ReactComponent as TelegramSvg } from '../../assets/icons/telegram-filled-rounded.svg';

export const TelegramFilledRoundedIcon: SvgIcon = (props) => {
    return <TelegramSvg {...props} />;
};
